import {gql} from '@apollo/client';
import {LoadingSpinner, showToast} from 'common';
import {useSearchParam} from 'common/hook';
import {useHandleGlobalError} from 'error';
import {Pane} from 'evergreen-ui';
import {toRelayId, useLazyQuery$} from 'graphqlsupport';
import {NewOfferForm} from 'offer';
import React, {useCallback, useEffect} from 'react';
import {Referral} from 'referral';
import {useObservable} from 'rxsupport';
import {OfferReferralDetail} from './component/OfferReferralDetail';
import {useGoToReferralListPage} from './core/routes';
import {REFERRAL_DETAIL_FOR_PROVIDER_FRAGMENT} from './hook/useReferralQueryForProvider$';
import {StandardLayout} from './layouts/StandardLayout';


type ReferralByRelayIdInput = {
    id: string;
};
type ReferralByRelayIdResult = {
    referral: Referral;
};
const REFERRAL_BY_RELAY_ID_QUERY = gql`
query Referral($id: ID!) {
  referral: providerReferralForNewOffer(id: $id) {
    ...${REFERRAL_DETAIL_FOR_PROVIDER_FRAGMENT.name}
  }
}
${REFERRAL_DETAIL_FOR_PROVIDER_FRAGMENT.value}
`;

export const NewOfferPage = () => {
    const referralGuid = useSearchParam().get('referralGuid');
    const {
        isRunning$,
        execute,
        data,
        error,
    } = useLazyQuery$<ReferralByRelayIdInput, ReferralByRelayIdResult>(
        REFERRAL_BY_RELAY_ID_QUERY, {
            id: toRelayId(referralGuid ?? '', 'Referral')
        });

    useEffect(() => {
        execute();
    }, [execute]);

    const loading = useObservable(isRunning$, false);

    const goToReferralPage = useGoToReferralListPage();

    const referralNumber = data?.referral?.caseNumber ?? '';
    const successCallback = useCallback(() => {
        showToast.success(`Offer for referral ${referralNumber} was submitted successfully`);
        goToReferralPage();
    }, [referralNumber, goToReferralPage]);

    const handleError = useCallback((anError: Error) => {
        showToast.error(anError.message);
        goToReferralPage();
    }, [goToReferralPage]);
    useHandleGlobalError(handleError);

    return (
        <StandardLayout>
            {loading && <LoadingSpinner centerScreen/>}
            {!loading && !error && !data && <Pane display='flex' className="portal-provider-content-container in-standard-layout"/>}
            {!loading && !error && data &&
            <Pane display='flex' className="portal-provider-content-container in-standard-layout">
                <OfferReferralDetail referral={data.referral}/>

                <Pane className="flex-grow">
                    <NewOfferForm referral={data.referral} successCallback={successCallback}/>
                </Pane>
            </Pane>
            }
        </StandardLayout>
    );
}
